import { toggleSingleSceneObject } from "../../togglers";

export const changeVerstakPolka = (side = null) => {
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const sizes = `${width}x${depth}`;
    const name = side
        ? `verstak__vs__polka_pri_odnoy_tumbe__${sizes}__${side}`
        : `verstak__vs__polka_pri_dvuh_tumbah__${sizes}`;

    toggleSingleSceneObject({
        allObjects: servObj.allVerstakPolka,
        activeArray: servObj.activeVerstakPolka,
        name,
        isChecked: true,
        position: { y: 10 },
        userData: { side },
    });
};
